module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/label-icon-buttons/label-icon-buttons.component.scss
// module id = ./src/app/features/buttons/label-icon-buttons/label-icon-buttons.component.scss
// module chunks = main